import { TOGGLE_SIDE_BAR } from "./headerType";

export const toggleSideBar = (object:any) => {
    return {
        type: TOGGLE_SIDE_BAR ,
        data: object
    }
}